// frontend/src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";

// Polyfill für HTML5 Drag & Drop auf Touch-Geräten (für Plan-View)
import { polyfill } from "mobile-drag-drop";
import "mobile-drag-drop/default.css";

// Polyfill initialisieren
polyfill({
  dragImageCenterOnTouch: true,
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);